import BancoDoBrasil from './BancoDoBrasil';

export default BancoDoBrasil;
